export default "__VITE_ASSET__1bobOneo__"